// ============================================
// PRODUCT PAGE JS
// ============================================

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.variantJson = document.querySelector('[data-product-json]');
    this.product = this.variantJson ? JSON.parse(this.variantJson.textContent) : null;
    
    if (!this.product) return;
    
    this.selects = this.querySelectorAll('[data-option-select]');
    this.buttons = this.querySelectorAll('[data-option-button]');
    
    this.selects.forEach(select => {
      select.addEventListener('change', () => this.onOptionChange());
    });
    
    this.buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        btn.closest('.product-form__options').querySelectorAll('[data-option-button]').forEach(b => {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        this.onOptionChange();
      });
    });
  }
  
  onOptionChange() {
    const options = this.getSelectedOptions();
    const variant = this.getVariantFromOptions(options);
    if (variant) this.updateVariant(variant);
  }
  
  getSelectedOptions() {
    const options = [];
    this.selects.forEach(select => options.push(select.value));
    this.querySelectorAll('.product-form__options').forEach(group => {
      const selected = group.querySelector('[data-option-button].is-selected');
      if (selected) options.push(selected.dataset.value);
    });
    return options;
  }
  
  getVariantFromOptions(options) {
    return this.product.variants.find(variant => {
      return options.every((option, index) => variant.options[index] === option);
    });
  }
  
  updateVariant(variant) {
    const input = this.form.querySelector('input[name="id"]');
    if (input) input.value = variant.id;
    
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    
    const priceEl = document.querySelector('[data-product-price]');
    if (priceEl) {
      let priceHtml = `<span class="product__price-current">${formatMoney(variant.price)}</span>`;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceHtml = `<span class="product__price-current product__price--sale">${formatMoney(variant.price)}</span><span class="product__price-compare">${formatMoney(variant.compare_at_price)}</span>`;
      }
      priceEl.innerHTML = priceHtml;
    }
    
    const button = this.form.querySelector('[data-add-to-cart]');
    const buttonText = button?.querySelector('[data-add-to-cart-text]');
    if (button && buttonText) {
      if (variant.available) {
        button.disabled = false;
        buttonText.textContent = 'Add to Cart';
      } else {
        button.disabled = true;
        buttonText.textContent = 'Sold Out';
      }
    }
    
    document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant, product: this.product } }));
  }
}
customElements.define('product-form', ProductForm);

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.main = this.querySelector('[data-main-image]');
    this.thumbnails = this.querySelectorAll('[data-thumbnail]');
    
    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => this.selectThumbnail(thumb));
    });
    
    document.addEventListener('variant:changed', (e) => {
      const variant = e.detail.variant;
      if (variant.featured_image) this.selectByImageId(variant.featured_image.id);
    });
  }
  
  selectThumbnail(thumb) {
    this.thumbnails.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    const img = thumb.querySelector('img');
    const mainImg = this.main.querySelector('img');
    if (img && mainImg) {
      mainImg.src = img.dataset.full || img.src.replace(/width=\d+/, 'width=800');
      mainImg.srcset = '';
    }
  }
  
  selectByImageId(imageId) {
    const thumb = Array.from(this.thumbnails).find(t => t.dataset.imageId == imageId);
    if (thumb) this.selectThumbnail(thumb);
  }
}
customElements.define('product-gallery', ProductGallery);

function formatMoney(cents) {
  const format = window.Shopify?.money_format || '${{amount}}';
  const value = (cents / 100).toFixed(2);
  return format.replace(/\{\{\s*(\w+)\s*\}\}/g, value);
}

console.log('Product page JS loaded');
